import { render, staticRenderFns } from "./BusinessPaymentOptionsView.vue?vue&type=template&id=3cf7f99e&scoped=true&"
import script from "./BusinessPaymentOptionsView.vue?vue&type=script&lang=ts&"
export * from "./BusinessPaymentOptionsView.vue?vue&type=script&lang=ts&"
import style0 from "./BusinessPaymentOptionsView.vue?vue&type=style&index=0&id=3cf7f99e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cf7f99e",
  null
  
)

export default component.exports